<template>
   <div >
    <!--prmanent-emp ref="prementEmp" refId="prementEmp" title="상주직원 정보 입력" :items="modalItems"/>
    <out-info ref="outInfo" refId="outInfo" title="퇴실정보입력" :items="modalItems"/>
    <enter-info ref="enterInfo" title="입실정보입력" :items="modalItems"/-->
    <page-header title="예약자 조회" description="예약자를 조회할 수 있습니다.">
      <div class="btn-wrap">
        <!--button class="btn btn-lg line-2" data-toggle="modal" data-target="#prementEmp">상주직원
          <i class="icon-plus ml-5"></i>
        </button-->
        <!--button class="btn btn-lg line-2 mr-5" data-toggle="modal" data-target="#enterInfo" @click="enter()">modal-lg / sample</button>
        <!--button class="btn btn-lg line-2" @click="create()">다운로드
          <i class="icon-excel ml-5"></i>
        </button-->
      </div>
    </page-header>
    <div class="page-body ph-30">
      <!-- serch-menu-area -->
      <div class="sticky-holder">
        <div class="control-group sticky wrap">
          <div class="control-row flex-wrap ps-re w-100" style="gap:10px">

            <div class="w-xl mr-8" style="width:310px">
              <div class="input-group date w-100"  style="margin-right:120px">
                <span class="input-group-addon title">기간선택</span>
                <input type="text" class="form-control" ui-jp="daterangepicker" ui-options='{opens:"right",drops:"down",rangeDatePicker:true,showDays:true,parentEl:$(this).parent(),timeInput:true,
                                  locale: {
                                      format: "YYYY-MM-DD HH:mm",
                                      timeFormat: "HH:mm",
                                      monthYearFormat: "YYYY년 M월",
                                      separator: " ~ ",
                                      daysOfWeek: ["일","월","화","수","목","금","토"],
                                      monthNames: ["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"]
                                  }}'>
                <button class="btn btn-md input-group-addon">
                  <i class="icon-calendar"></i>
                </button>
              </div>
            </div>

            <div class="input-group align-top mr-10">
              <dropdown v-model="search.status" :datasource="statusDropList" title="상태" :isSelectionFirstData="true" inline="inline"/>
            </div>

            <div class="input-group align-top mr-10">
              <dropdown v-model="search.term" :datasource="termList" title="장/단기" :isSelectionFirstData="true" inline="inline"/>
            </div>

            <div class="input-group align-top">
              <dropdown v-model="search.zone" :datasource="zoneList" title="존" :isSelectionFirstData="true" inline="inline"/>
            </div>

            <div class="flex-break flex-break-1430-reset"></div>

            <div class="input-group mr-8">
              <span class="input-group-addon title">티켓번호</span>
              <input type="text" class="form-control" placeholder="NTREE티켓번호를 입력하세요.">
            </div>

            <div class="input-group mr-8">
              <span class="input-group-addon title">이름</span>
              <input type="text" class="form-control" placeholder="출입자이름을 입력하세요.">
            </div>

            <div class="input-group mr-8">
              <span class="input-group-addon title">차량번호</span>
              <input type="text" class="form-control" placeholder="차량번호를 입력하세요.">
            </div>

            <div class="input-group align-top mr-10">
              <dropdown v-model="idcSelctedItem" :datasource="idcList" title="회사명" :isSelectionFirstData="true" inline="inline"/>
            </div>

            <!--label class="md-check no-wrap pt-5 ml-8">
              <input type="checkbox" checked="">
              <i class="blue"></i>삭제 포함</label-->

            <button class="btn btn-md line-1">Reset</button>
            <button class="btn btn-md blue ml-6">검색</button>

            <div class="abs-br-zero">
              <button class="btn btn-md line-2" title="현재 조회된 발송 목록 결과를 다운로드 가능한 Excel 파일로 생성 요청하거나, 파일 생성 요청 목록을 확인한 후 파일을 다운로드할 수 있습니다." data-toggle="tooltip" data-placement="right"><i class="icon-excel mr-5 font-size-11"></i>다운로드 요청 / 목록</button>
            </div>
          </div>
        </div>
      </div>
      <!-- //search-menu-area -->
      <table class="tbl select-tbl">
        <colgroup>
          <col width="42px">
          <col width="270px">
          <col width="120px">
          <col width="auto">
          <col width="270px">
          <col width="auto">
          <col width="auto">
          <col width="10%">
          <col width="10%">
          <col width="50px">
        </colgroup>
        <thead>
          <tr>
            <th>
              <label class="md-check">
                <input type="checkbox" class="has-value" v-model="isCheckedAll" @change="itemCheckAll()">
                <i class="blue"></i>
              </label>
            </th>
            <th>티켓번호</th>
            <th>이름</th>
            <th>회사명</th>
            <th>출입기간</th>
            <th>담당자</th>
            <th>반입자산</th>
            <th>차량정보</th>
            <th>상태</th>
            <th></th>
          </tr>
        </thead>

        <tbody v-for="(item, index) in items" :key="index">
          <tr >
            <td>
              <label class="md-check">
                <input type="checkbox" class="has-value" @click="itemClick(item)" v-model="item.isChecked">
                <i class="blue"></i>
              </label>
            </td>
            <td>{{item.ntreeTicket}}</td>
            <td>{{item.visitorName}}</td>
            <td>{{item.visitorCompany}}</td>
            <td>{{getDueDate(item.fromDate, item.toDate)}}</td>
            <td>{{item.empName}}</td>
            <td>{{getAssetNames(item.visitorAssets)}}</td>
            <td>{{item.carNumber}}</td>
            <td><i :class="['dot', getStatus(item)]"></i> {{statusDropList[item.statusCode].name}}</td>

            <td>
              <a @click="open(item)">
                <i :class="['icon', item.isOpen ? 'icon-arrow-line-up' : 'icon-arrow-line-down']"></i>
              </a>
            </td>
          </tr>
          <tr :class="['detail', item.isOpen ? '' : 'hide']">
            <td colspan="10">
              <h4>출입자 상세정보</h4>
              <div class="result-tbl m-t-sm">
                <table class="tbl">
                  <tbody>

                    <tr>
                    <col-field  label="티켓 번호">
                      <Input :value="item.ntreeTicket" placeholder="티켓 번호"/>
                    </col-field>
                    <th>출입요청 기간</th>
                    <td>{{getDueDate(item.fromDate, item.toDate)}}</td>
                  </tr>
                  <tr>
                    <th>이름

                    </th>
                    <td><Input :editMode="true"/></td>
                    <th>회사명
                    </th>
                    <td>{{item.visitorCompany}}
                    </td>
                  </tr>
                  <tr>
                    <th>담당자
                      <!--button class="btn btn-sm line-3 ml-5">Edit</button-->
                    </th>
                    <td>{{item.empName}}</td>
                    <th>방문목적</th>
                    <td>{{item.visitTypeCode}}
                    </td>
                  </tr>
                  <tr>
                    <th>상태
                    </th>
                    <td><i :class="['dot', getStatus(item)]"></i> {{statusDropList[item.statusCode].name}}</td>

                  </tr>
                </tbody></table>
              </div>
              <h4 class="mt-20">반입자산</h4>
              <table class="tbl outline m-t-sm">
                <colgroup>
                  <col width="10%">
                  <col width="20%">
                  <col width="20%">
                  <col width="20%">
                  <col width="30%">
                </colgroup>
                <thead>
                <tr>
                  <th>항목</th>
                  <th>제조사</th>
                  <th>모델명</th>
                  <th>시리얼번호</th>
                  <th>비고</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(asset, assetIndex) in item.visitorAssets" :key="assetIndex">
                  <td>{{asset.assetCode}}</td>
                  <td>{{asset.assetManufacturer}}</td>
                  <td>{{asset.assetModel}}</td>
                  <td>{{asset.assetSerial}}</td>
                  <td>{{asset.assetMemo}}</td>
                </tr>
                </tbody>
              </table>


              <h4 class="mt-20">출입위치</h4>
              <table class="tbl outline m-t-sm">
                <colgroup>
                  <col width="20%">
                  <col width="20%">
                  <col width="60%">
                </colgroup>
                <thead>
                <tr>
                  <th>관</th>
                  <th>층</th>
                  <th>상세위치</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(location, locationIndex) in item.locationList" :key="locationIndex">
                  <td>{{location.hall}}</td>
                  <td>{{location.floor}}</td>
                  <td>{{location.path}}</td>
                </tr>
                </tbody>
              </table>


            <h4 class="mt-20">출입위치</h4>
             <div class="result-tbl m-t-sm">
                <table class="tbl">
                  <tbody>

                    <tr>
                    <col-field  label="차종">
                      <Input :value="item.carModel" placeholder="차종"/>
                    </col-field>
                    <col-field  label="차량번호">
                      <Input :value="item.carNumber" placeholder="차량번호"/>
                    </col-field>
                  </tr>
                  <tr>
                    <th>비고

                    </th>
                    <td>{{item.etc}}</td>
                  </tr>
                </tbody></table>
              </div>
            </td>
          </tr>
        </tbody>

      </table>
      <div class="ps-re">
        <div class="inline abs-tl-zero white" style="min-size: 135px;height: 26px;line-height: 26px;padding: 0 12px;">
          Total Item: <span class="text-light-blue">1</span>
        </div>
        <ul class="pagination mt-30 justify-content-center">
          <li>
            <a href="">
              <i class="icon-arrow-line-left"></i>
            </a>
          </li>
          <li class="active">
            <a href="">1</a>
          </li>
          <li>
            <a href="">2</a>
          </li>
          <li>
            <a href="">3</a>
          </li>
          <li>
            <a href="">4</a>
          </li>
          <li>
            <a href="">5</a>
          </li>
          <li>
            <a href="">
              <i class="icon-arrow-line-right"></i>
            </a>
          </li>
        </ul>
        <div class="dropdown inline abs-br-zero dropup">
          <button class="btn btn-md line-2 dropdown-toggle" data-toggle="dropdown" aria-expanded="false">20개씩 보기</button>
          <div class="dropdown-menu dropdown-menu-scale">
            <a class="dropdown-item selected">20개씩 보기</a>
            <a class="dropdown-item">40개씩 보기</a>
            <a class="dropdown-item">60개씩 보기</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from "@/components/Dropdown.vue"
import Input from "@/components/Input.vue"
import PageHeader from '@/layout/PageHeader.vue';
import ColField from '@/components/ColField.vue';
import EnterInfo from './EnterInfo.vue';
import OutInfo from './OutInfo.vue';
import PrmanentEmp from './PrmanentEmp.vue';

export default {
  components: { Dropdown, PageHeader,Input, ColField, EnterInfo, OutInfo, PrmanentEmp},
  data(){

     return {
      search: {},
      isCheckedAll: false,
      selectedStatsItem: null,
      selectedTypeItem: null,
      statusDropList: [{name: '전체', value: null, isChecked: true}, {name: '담당임직원 승인대기', value: 1}, {name: '내부결재 진행중', value: 2}, {name: '승인완료', value: 3}, {name: '승인거절', value: 4}, {name: '입/퇴실완료', value: 4}],
      zoneList: [{name: '전체', value: null, isChecked: true}, {name: '일반존', value: 0, isChecked: true}, {name: '공공금융존', value: 1}],
      termList: [{name: '전체', value: null, isChecked: true}, {name: '장기출입자', value: 0, isChecked: true}, {name: '단기출입자', value: 1}],
      searchTypeItem: {},
      searchTypeList: [{name: '이름', value: 'visitorName'}, {name: '회사명', value: 'visitorCompany'}, {name: '티켓번호', value: 'ntreeTicket'}],
      userTypeItem: {},
      userTypeList: [{name:'일반사용자', value: 1}, {name: 'IDC 사용자', value: 2}, {name: 'IDC 운영자', value: 3}, {name: '보안담당자 및 시스템 관리자', value: 4}],
      idcSelctedItem: {name: '판교', vlaue: 0},
      idcList: [{name: '판교', value: 0}, {name: '데이터센터 각', value: 1},],
      modalItems: [],
      rowItem : {
        uuid:'122345',
        ntreeTicket:'a1c1b305-12fc-4757-ad96-1ed07d4de240',
        visitorName:'황의종',
        visitorPhone:'01092936777',
        visitorMail:'euizong@gmail.com',
        visitorCompany:'디와이즈',
        empName:'강선호',
        empEmail:'seonho.kang@navercorp.com',
        reservationTimestamp:'1623639578969',
        fromDate:'1624244400000',
        toDate:'1624269540000',
        visitTypeCode:'',
        carModel:'TESLA',
        carNumber:'07수6141',
        etc:'비고입니다.',
        statusCode:'',
        visitIdcCode:'N2CDT001060',
        visitLocation:'[["N2CDT001060","N2CDT008300","N2CDT008320","N2CDT012480"],["N2CDT001060","N2CDT008300","N2CDT008320","N2CDT012490"],["N2CDT001060","N2CDT008300","N2CDT008320","N2CDT012480"]]',
        reservationType:'VMS',
        shortCut:'',
        isApplicant:'0',
        isChecked: false,
        isOpen: false,
        roomNo: null,
        cardNo: null,
        locationList: [
          {hall: '납관', floor: 1, path: '데이터센터각 > 남관 > 1층'},
          {hall: '북관', floor: 1, path: '데이터센터각 > 북관 > 1층'}
        ],
        visitorAssets: [
          {
            visitorId:'122345',
            assetCode:'1',
            assetManufacturer:'Apple',
            assetModel:'MacBook Air M1',
            assetSerial:'FVFF0002927',
            assetMemo:'회의용 노트북',
            assetStr: '노트북',
            isReserved:'1',
            isUsed:'1'
          },
          {
            visitorId:'122345',
            assetCode:'1',
            assetManufacturer:'Apple',
            assetModel:'IPhone X',
            assetSerial:'FVFF0002927',
            assetMemo:'업무용 전화',
            assetStr: '핸드폰',
            isReserved:'1',
            isUsed:'1'
          },
        ]
      },

      //rowItem : {uuid: '12345', ntreeTicket: 'TSA20160101000004', visitorName: '황의종', start: moment('2021-07-20').valueOf(), end: moment('2021-07-23').valueOf(), email: 'seonho.kang@navercorp.com', empNo: 'NB11727', empType: '시스템관리자', empLevel: '가산, 대전, 부산, 여의도, 춘천, 판교, 평촌', empMainIdc: '춘천', isChecked: false, isOpen: false, createDate: '2021-07-07', modifiedDate: '2021-07-07'},
      items: []
    }
  },
  mounted(){
    this.init();
  },
  computed: {
    getStatus(){
      return (item) => {
        var color = 'grey'
        if(item.statusCode == 1 || item.statusCode == 2)
          color = 'yellow';
        if(item.statusCode == 3)
          color = 'green';
        if(item.statusCode == 4)
          color = 'red';
        return color;
      }
    },
    getDueDate() {
      return (from, to) => {
        return moment(Number(from)).format('YYYY-MM-DD HH:mm:SS') +'~' + moment(Number(to)).format('YYYY-MM-DD HH:mm:SS');
      }
    },
    getAssetNames() {
      return (assets) =>{
        return _.map(assets, 'assetStr').join(", ");
      }
    },
    getCheckedItem() {
      return (items) => {
        return _.find(items, {isChecked:true})
      }
    }
  },
  methods: {
    init(){
      var that = this;
      $('[data-toggle="modal"]').on('click', (e) =>{
        //that.$refs.enterInfo.$set('title','test')
        //that.$refs.enterInfo.title = 'test';

      });
      for(var i=0; i<20; i++){
        var item = Object.assign({id: i+1}, this.rowItem);
        this.items.push(item);
        item.isChecked = false;
        if(i < 20)
          item.statusCode = 5;
        if(i < 16)
          item.statusCode = 4;
        if(i < 12)
          item.statusCode = 3;
        if(i < 8)
          item.statusCode = 2;
        if(i < 4)
          item.statusCode = 1;

      }
    },
    itemClick(item) {
      item.isChecked = !item.isChecked;
    },
    itemCheckAll(){
      var that = this;
      _.map(that.items, (x) => {x.isChecked = that.isCheckedAll})
    },
    statusDropItemClick(item){
      this.statusDropList.forEach((x)=>{
        x.isChecked = false;
      })
      item.isChecked = true;
      this.selectedStatsItem = item;
    },
    typeDropItemClick(item){
      this.typeDropList.forEach((x)=>{
        x.isChecked = false;
      })
      item.isChecked = true;
      this.selectedTypeItem = item;
    },
    enter(){
      //data-target="#large"
      //this.$router.push({ path: '/app/user', query: {mode: 'new'}})

      this.modalItems = this.items.filter((x) => {return x.isChecked})
    },
    out(){
      this.modalItems = this.items.filter((x) => {return x.isChecked})
    },
    prementEmp(){
      this.modalItems = this.items.filter((x) => {return x.isChecked})
    },
    PromiseRejectionEvent(){
      this.modalItems = this.items.filter((x) => {return x.isChecked})
    },
    view(){
      this.$router.push({ path: '/app/notice', query: {mode: 'view'}})
    },
    open(item){
      var cItem = Object.assign({}, item);
      this.items.forEach((x) => {
        x.isOpen = false;
      })
      item.isOpen = !cItem.isOpen;
    }
  }
}
</script>

<style>

</style>
